varying float vAlpha;
varying float vHeat;

void main() {
    vec2 uv = gl_PointCoord - vec2(0.5);
    float dist = length(uv) * 2.0;
    
    // М'яка частка (Gaussian-like falloff)
    float mask = exp(-dist * dist * 4.0); 

    // Кольорова карта (Heat Mapping)
    // 1.0 (Основа) -> Біло-блакитний / Яскраво-жовтий
    // 0.7 -> Оранжевий
    // 0.4 -> Темно-червоний
    // 0.1 -> Чорний (Дим)
    
    vec3 color = vec3(0.0);
    
    if (vHeat > 0.96) { // Поріг підвищено до 0.98 — біла зона вдвічі вужча
        // Ядро — тонка серединка від золотавого до теплого вершкового (не чисто білого)
        color = mix(vec3(1.0, 0.85, 0.3), vec3(1.0, 0.95, 0.6), (vHeat - 0.96) * 50.0);
    }
    else if (vHeat > 0.4) {
        // Основне полум'я — жовто-оранжевий діапазон (0.4 → 0.98)
        color = mix(vec3(1.0, 0.2, 0.0), vec3(1.0, 0.82, 0.2), (vHeat - 0.4) * 1.724);
    } else {
        // Згасання (червоний -> попіл)
        color = mix(vec3(0.1, 0.1, 0.1), vec3(0.8, 0.1, 0.0), vHeat * 2.5);
    }

    // Пригнічуємо яскравість країв, щоб не було "квадратиків"
    // * 0.35 — зменшуємо внесок кожної частинки щоб AdditiveBlending не давав білий
    float alpha = mask * vAlpha * 0.35;
    
    // Для імітації інтенсивності згоряння (Blackbody radiation)
    // підсилюємо колір у центрі
    gl_FragColor = vec4(color * (0.45 + vHeat * 0.2), alpha);

    #include <colorspace_fragment>
}